const Footer = () => {

  const date = new Date().getFullYear();
  return <section id="footer">
      <p><i className="fa-solid fa-copyright"></i>  {date} Abhishek Kumar</p>
      <p>Thank You for visiting my portfolio website <i className="fa-solid fa-heart"></i></p>
  </section>;
};

export default Footer;
